/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Col_StandingsInputs */



/**
* | output |
* | --- |
* | "Standings" |
*
* @param {League_Col_StandingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_col_standings = /** @type {((inputs?: League_Col_StandingsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Col_StandingsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Classement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Clasificación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Classificação")
	if (locale === "it") return /** @type {LocalizedString} */ ("Classifica")
	return /** @type {LocalizedString} */ ("Standings")
});